import {
  subscriptionStatus,
  subscriptionCancel,
  subscriptionPause,
  subscriptionResume,
  subscriptionChangeAmount,
  updatePaymentInDB,
  walletCredit,
  initPaymentInDB,
  initStripeIntent,
  confirmStripePayment,
} from '../../util/api';

// ================ Action Types ================

export const FETCH_SUB_STATUS_REQUEST = 'app/SubscriptionPlan/FETCH_SUB_STATUS_REQUEST';
export const FETCH_SUB_STATUS_SUCCESS = 'app/SubscriptionPlan/FETCH_SUB_STATUS_SUCCESS';
export const FETCH_SUB_STATUS_ERROR = 'app/SubscriptionPlan/FETCH_SUB_STATUS_ERROR';

export const CANCEL_SUB_REQUEST = 'app/SubscriptionPlan/CANCEL_SUB_REQUEST';
export const CANCEL_SUB_SUCCESS = 'app/SubscriptionPlan/CANCEL_SUB_SUCCESS';
export const CANCEL_SUB_ERROR = 'app/SubscriptionPlan/CANCEL_SUB_ERROR';

export const PAUSE_SUB_REQUEST = 'app/SubscriptionPlan/PAUSE_SUB_REQUEST';
export const PAUSE_SUB_SUCCESS = 'app/SubscriptionPlan/PAUSE_SUB_SUCCESS';
export const PAUSE_SUB_ERROR = 'app/SubscriptionPlan/PAUSE_SUB_ERROR';

export const RESUME_SUB_REQUEST = 'app/SubscriptionPlan/RESUME_SUB_REQUEST';
export const RESUME_SUB_SUCCESS = 'app/SubscriptionPlan/RESUME_SUB_SUCCESS';
export const RESUME_SUB_ERROR = 'app/SubscriptionPlan/RESUME_SUB_ERROR';

export const CHANGE_SUB_REQUEST = 'app/SubscriptionPlan/CHANGE_SUB_REQUEST';
export const CHANGE_SUB_SUCCESS = 'app/SubscriptionPlan/CHANGE_SUB_SUCCESS';
export const CHANGE_SUB_ERROR = 'app/SubscriptionPlan/CHANGE_SUB_ERROR';

export const UPDATE_PAYMENT_REQUEST = 'app/SubscriptionPlan/UPDATE_PAYMENT_REQUEST';
export const UPDATE_PAYMENT_SUCCESS = 'app/SubscriptionPlan/UPDATE_PAYMENT_SUCCESS';
export const UPDATE_PAYMENT_ERROR = 'app/SubscriptionPlan/UPDATE_PAYMENT_ERROR';

export const CREDIT_WALLET_REQUEST = 'app/SubscriptionPlan/CREDIT_WALLET_REQUEST';
export const CREDIT_WALLET_SUCCESS = 'app/SubscriptionPlan/CREDIT_WALLET_SUCCESS';
export const CREDIT_WALLET_ERROR = 'app/SubscriptionPlan/CREDIT_WALLET_ERROR';

export const INITIALIZE_PAYMENT_REQUEST = 'app/SubscriptionPlan/INITIALIZE_PAYMENT_REQUEST';
export const INITIALIZE_PAYMENT_SUCCESS = 'app/SubscriptionPlan/INITIALIZE_PAYMENT_SUCCESS';
export const INITIALIZE_PAYMENT_ERROR = 'app/SubscriptionPlan/INITIALIZE_PAYMENT_ERROR';

export const INITIALIZE_STRIPE_INTENT_REQUEST =
  'app/SubscriptionPlan/INITIALIZE_STRIPE_INTENT_REQUEST';
export const INITIALIZE_STRIPE_INTENT_SUCCESS =
  'app/SubscriptionPlan/INITIALIZE_STRIPE_INTENT_SUCCESS';
export const INITIALIZE_STRIPE_INTENT_ERROR = 'app/SubscriptionPlan/INITIALIZE_STRIPE_INTENT_ERROR';

export const CONFIRM_STRIPE_PAYMENT_REQUEST = 'app/SubscriptionPlan/CONFIRM_STRIPE_PAYMENT_REQUEST';
export const CONFIRM_STRIPE_PAYMENT_SUCCESS = 'app/SubscriptionPlan/CONFIRM_STRIPE_PAYMENT_SUCCESS';
export const CONFIRM_STRIPE_PAYMENT_ERROR = 'app/SubscriptionPlan/CONFIRM_STRIPE_PAYMENT_ERROR';

// ================ Initial State ================

const initialState = {
  subStatus: null,
  fetchSubError: null,
  loadingSub: false,
  actionError: null,

  updatePaymentInProgress: false,
  updatePaymentError: null,
  creditWalletInProgress: false,
  creditWalletError: null,
  initializePaymentInProgress: false,
  initializePaymentError: null,
  initializeStripeIntentInProgress: false,
  initializeStripeIntentError: null,
  confirmStripePaymentInProgress: false,
  confirmStripePaymentError: null,
};

// ================ Reducer ================

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_SUB_STATUS_REQUEST:
      return { ...state, fetchSubError: null, loadingSub: true };
    case FETCH_SUB_STATUS_SUCCESS:
      return { ...state, subStatus: payload, loadingSub: false };
    case FETCH_SUB_STATUS_ERROR:
      return { ...state, fetchSubError: payload, loadingSub: false };

    case CANCEL_SUB_REQUEST:
    case PAUSE_SUB_REQUEST:
    case RESUME_SUB_REQUEST:
    case CHANGE_SUB_REQUEST:
      return { ...state, actionError: null, loadingSub: true };

    case CANCEL_SUB_SUCCESS:
    case PAUSE_SUB_SUCCESS:
    case RESUME_SUB_SUCCESS:
    case CHANGE_SUB_SUCCESS:
      return { ...state, loadingSub: false };

    case CANCEL_SUB_ERROR:
    case PAUSE_SUB_ERROR:
    case RESUME_SUB_ERROR:
    case CHANGE_SUB_ERROR:
      return { ...state, actionError: payload, loadingSub: false };

    case UPDATE_PAYMENT_REQUEST:
      return { ...state, updatePaymentInProgress: true, updatePaymentError: null };
    case UPDATE_PAYMENT_SUCCESS:
      return { ...state, updatePaymentInProgress: false };
    case UPDATE_PAYMENT_ERROR:
      return { ...state, updatePaymentInProgress: false, updatePaymentError: payload };

    case CREDIT_WALLET_REQUEST:
      return { ...state, creditWalletInProgress: true, creditWalletError: null };
    case CREDIT_WALLET_SUCCESS:
      return { ...state, creditWalletInProgress: false };
    case CREDIT_WALLET_ERROR:
      return { ...state, creditWalletInProgress: false, creditWalletError: payload };

    case INITIALIZE_PAYMENT_REQUEST:
      return { ...state, initializePaymentInProgress: true, initializePaymentError: null };
    case INITIALIZE_PAYMENT_SUCCESS:
      return { ...state, initializePaymentInProgress: false };
    case INITIALIZE_PAYMENT_ERROR:
      return { ...state, initializePaymentInProgress: false, initializePaymentError: payload };

    case INITIALIZE_STRIPE_INTENT_REQUEST:
      return {
        ...state,
        initializeStripeIntentInProgress: true,
        initializeStripeIntentError: null,
      };
    case INITIALIZE_STRIPE_INTENT_SUCCESS:
      return { ...state, initializeStripeIntentInProgress: false };
    case INITIALIZE_STRIPE_INTENT_ERROR:
      return {
        ...state,
        initializeStripeIntentInProgress: false,
        initializeStripeIntentError: payload,
      };

    case CONFIRM_STRIPE_PAYMENT_REQUEST:
      return { ...state, confirmStripePaymentInProgress: true, confirmStripePaymentError: null };
    case CONFIRM_STRIPE_PAYMENT_SUCCESS:
      return { ...state, confirmStripePaymentInProgress: false };
    case CONFIRM_STRIPE_PAYMENT_ERROR:
      return {
        ...state,
        confirmStripePaymentInProgress: false,
        confirmStripePaymentError: payload,
      };

    default:
      return state;
  }
}

// ================ Action Creators ================

export const fetchSubStatusRequest = () => ({ type: FETCH_SUB_STATUS_REQUEST });
export const fetchSubStatusSuccess = payload => ({ type: FETCH_SUB_STATUS_SUCCESS, payload });
export const fetchSubStatusError = payload => ({ type: FETCH_SUB_STATUS_ERROR, payload });

export const cancelSubRequest = () => ({ type: CANCEL_SUB_REQUEST });
export const cancelSubSuccess = () => ({ type: CANCEL_SUB_SUCCESS });
export const cancelSubError = payload => ({ type: CANCEL_SUB_ERROR, payload });

export const pauseSubRequest = () => ({ type: PAUSE_SUB_REQUEST });
export const pauseSubSuccess = () => ({ type: PAUSE_SUB_SUCCESS });
export const pauseSubError = payload => ({ type: PAUSE_SUB_ERROR, payload });

export const resumeSubRequest = () => ({ type: RESUME_SUB_REQUEST });
export const resumeSubSuccess = () => ({ type: RESUME_SUB_SUCCESS });
export const resumeSubError = payload => ({ type: RESUME_SUB_ERROR, payload });

export const changeSubRequest = () => ({ type: CHANGE_SUB_REQUEST });
export const changeSubSuccess = () => ({ type: CHANGE_SUB_SUCCESS });
export const changeSubError = payload => ({ type: CHANGE_SUB_ERROR, payload });

export const updatePaymentRequest = () => ({ type: UPDATE_PAYMENT_REQUEST });
export const updatePaymentSuccess = () => ({ type: UPDATE_PAYMENT_SUCCESS });
export const updatePaymentError = payload => ({ type: UPDATE_PAYMENT_ERROR, payload });

export const creditWalletRequest = () => ({ type: CREDIT_WALLET_REQUEST });
export const creditWalletSuccess = () => ({ type: CREDIT_WALLET_SUCCESS });
export const creditWalletError = payload => ({ type: CREDIT_WALLET_ERROR, payload });

export const initializePaymentRequest = () => ({ type: INITIALIZE_PAYMENT_REQUEST });
export const initializePaymentSuccess = () => ({ type: INITIALIZE_PAYMENT_SUCCESS });
export const initializePaymentError = payload => ({ type: INITIALIZE_PAYMENT_ERROR, payload });

export const initializeStripeIntentRequest = () => ({ type: INITIALIZE_STRIPE_INTENT_REQUEST });
export const initializeStripeIntentSuccess = () => ({ type: INITIALIZE_STRIPE_INTENT_SUCCESS });
export const initializeStripeIntentError = payload => ({
  type: INITIALIZE_STRIPE_INTENT_ERROR,
  payload,
});

export const confirmStripePaymentRequest = () => ({ type: CONFIRM_STRIPE_PAYMENT_REQUEST });
export const confirmStripePaymentSuccess = () => ({ type: CONFIRM_STRIPE_PAYMENT_SUCCESS });
export const confirmStripePaymentError = payload => ({
  type: CONFIRM_STRIPE_PAYMENT_ERROR,
  payload,
});

// ================ Thunk Actions ================

export const fetchSubscriptionStatus = ({ userId }) => async dispatch => {
  dispatch(fetchSubStatusRequest());
  try {
    const res = await subscriptionStatus({ userId });
    if (res.success) {
      dispatch(fetchSubStatusSuccess(res.data));
      return res.data;
    } else {
      throw new Error(res.message || 'Failed to fetch subscription status');
    }
  } catch (err) {
    const errMsg = err?.message || 'Failed to fetch subscription status';
    dispatch(fetchSubStatusError(errMsg));
    throw err;
  }
};

export const cancelSubscription = ({ userId }) => async dispatch => {
  dispatch(cancelSubRequest());
  try {
    const res = await subscriptionCancel({ userId });
    if (res.success) {
      dispatch(cancelSubSuccess());
      dispatch(fetchSubscriptionStatus({ userId }));
      return res;
    } else {
      throw new Error(res.message || 'Failed to cancel subscription');
    }
  } catch (err) {
    dispatch(cancelSubError(err?.message || 'Failed to cancel subscription'));
    throw err;
  }
};

export const pauseSubscription = ({ userId }) => async dispatch => {
  dispatch(pauseSubRequest());
  try {
    const res = await subscriptionPause({ userId });
    if (res.success) {
      dispatch(pauseSubSuccess());
      dispatch(fetchSubscriptionStatus({ userId }));
      return res;
    } else {
      throw new Error(res.message || 'Failed to pause subscription');
    }
  } catch (err) {
    dispatch(pauseSubError(err?.message || 'Failed to pause subscription'));
    throw err;
  }
};

export const resumeSubscription = ({ userId }) => async dispatch => {
  dispatch(resumeSubRequest());
  try {
    const res = await subscriptionResume({ userId });
    if (res.success) {
      dispatch(resumeSubSuccess());
      dispatch(fetchSubscriptionStatus({ userId }));
      return res;
    } else {
      throw new Error(res.message || 'Failed to resume subscription');
    }
  } catch (err) {
    dispatch(resumeSubError(err?.message || 'Failed to resume subscription'));
    throw err;
  }
};

export const changeSubscriptionPlan = ({ userId, planId }) => async dispatch => {
  dispatch(changeSubRequest());
  try {
    const res = await subscriptionChangeAmount({ userId, planId });
    if (res.success) {
      dispatch(changeSubSuccess());
      dispatch(fetchSubscriptionStatus({ userId }));
      return res;
    } else {
      throw new Error(res.message || 'Failed to change subscription plan');
    }
  } catch (err) {
    dispatch(changeSubError(err?.message || 'Failed to change subscription plan'));
    throw err;
  }
};

export const updatePayment = params => async dispatch => {
  dispatch(updatePaymentRequest());
  try {
    const res = await updatePaymentInDB(params);
    dispatch(updatePaymentSuccess());
    return res;
  } catch (err) {
    const errMsg = err?.message || 'Failed to update payment record';
    dispatch(updatePaymentError(errMsg));
    throw err;
  }
};

export const creditWallet = params => async dispatch => {
  dispatch(creditWalletRequest());
  try {
    const res = await walletCredit(params);
    dispatch(creditWalletSuccess());
    return res;
  } catch (err) {
    const errMsg = err?.message || 'Failed to credit wallet';
    dispatch(creditWalletError(errMsg));
    throw err;
  }
};

export const initializePayment = params => async dispatch => {
  dispatch(initializePaymentRequest());
  try {
    const res = await initPaymentInDB(params);
    dispatch(initializePaymentSuccess());
    return res;
  } catch (err) {
    const errMsg = err?.message || 'Failed to initialize payment record';
    dispatch(initializePaymentError(errMsg));
    throw err;
  }
};

export const initializeStripeIntent = params => async dispatch => {
  dispatch(initializeStripeIntentRequest());
  try {
    const res = await initStripeIntent(params);
    dispatch(initializeStripeIntentSuccess(res));
    return res;
  } catch (err) {
    const errMsg = err?.message || 'Failed to initialize Stripe PaymentIntent';
    dispatch(initializeStripeIntentError(errMsg));
    throw err;
  }
};

export const confirmStripePaymentOnServer = params => async dispatch => {
  dispatch(confirmStripePaymentRequest());
  try {
    const res = await confirmStripePayment(params);
    dispatch(confirmStripePaymentSuccess());
    return res;
  } catch (err) {
    const errMsg = err?.message || 'Failed to confirm Stripe payment on server';
    dispatch(confirmStripePaymentError(errMsg));
    throw err;
  }
};

// ================ Static loadData Loader ================

export const loadData = (params, search) => (dispatch, getState) => {
  const state = getState();
  const userId = state.user.currentUser?.id?.uuid;
  if (userId) {
    return dispatch(fetchSubscriptionStatus({ userId })).catch(() => {});
  }
  return Promise.resolve();
};
